module fdm.pilotPerformance {

    class PilotAnalysedEventsWidgetController {


        public link: dg.restfulApi.Link;

        public query: any;
        public queryManipulator: dg.actions.ServerQueryManipulator;
        
        public options = dg.lists.ListOptionsService.getGridOptions({
            type: 'grid',
            actionColumnEnabled: false,
            useExternalSorting: false,
            useGridScroll: false,
            uiGrid: {
                enableSorting: false,
                columnDefs: [
                    { field: 'level', minWidth: 55 },
                    { field: 'aggregate', minWidth: 80 },
                    { field: 'description', width: '20%' },
                    { field: 'aircraft', width: 80 },
                    { field: 'leg', width: 85 },
                    { field: 'legDate', minWidth: 115 },
                    { field: 'departure', minWidth: 60 },
                    { field: 'arrival', minWidth: 60 },
                    { field: 'parameter', minWidth: 80 },
                    { field: 'exceedance', minWidth: 60 },
                    { field: 'value', minWidth: 60 },
                    { field: 'unit', minWidth: 50 },

                    { field: 'phase', minWidth: 50 },
                    { field: 'threshold', visible: false },
                    { field: 'pilotFlying', visible: false },
                    { field: 'airport', visible: false },
                    { field: 'family', visible: false },
                    { field: 'status', visible: false },
                    { field: 'acceptedOrRejectedComment', visible: false },
                    { field: 'smsIntegrationStatus', visible: false },
                    { field: 'smsIntegrationMessage', visible: false },
                    { field: 'precursor',  visible: false },
                ]
            },

        });


        public constructor(
            public $scope: any,
            private $q: ng.IQService,
            private $element: ng.IAugmentedJQuery,
            protected actionService: dg.actions.ActionService) {
        }

        $onChanges(changes) {
            if (changes.link.currentValue) {
              this.getData();
            }
        }

        async getData() {
            this.query = await this.actionService.getActionFromLink(this.link);
            this.queryManipulator = new dg.actions.ServerQueryManipulator(this.$scope, this.$q, this.query, this.actionService);
            this.queryManipulator.executeQuery();
        }
    };

    angular.module('fdm.pilotPerformance').component('pilotAnalysedEventsWidget', {
        bindings: {
            link: '<'
        },
        controller: PilotAnalysedEventsWidgetController,
        templateUrl: '/app/src/pilot-performance/pilot-analysed-events-widget.html'
    });
}